import React, { useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    btnExport,
    btnSearch,
    
    onImport  
} from '../../store/fuerzaventas/cargamasivarutas/actions';

import { Body, Footer, Page } from '@sigeco/tools';
import Backdrop from '@material-ui/core/Backdrop';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Icon from '@material-ui/core/Icon';

import CargaMasivaRutasFilter from '../../components/fuerzaventas/cargamasivarutas/CargaMasivaRutasFilter';
import CargaMasivaRutasPanel from '../../components/fuerzaventas/cargamasivarutas/CargaMasivaRutasPanel';

const CargaMasivaRutas = ({onClose, setTitle}) => {
    const loading = useSelector(state => state.cargamasivarutas.loading);
    const valor = useSelector(state => state.cargamasivarutas.filters.valor);
    const data = useSelector(state => state.cargamasivarutas.store.data5);
    const dispatch = useDispatch();
    
    useEffect(() => {
        setTitle('Búsqueda');
    // eslint-disable-next-line
    }, []);

    function onBtnClose() {
        onClose();
    }

    return (
        <Page>
            <Backdrop style={{ position: 'absolute', zIndex: 1200 }} open={loading} transitionDuration={0}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Body>
                 <CargaMasivaRutasFilter />
                <CargaMasivaRutasPanel />
            </Body>
            <Footer>
                <Button
                    color="primary"
                    size="small"
                    variant="outlined"
                    onClick={() => dispatch(onImport())}
                    startIcon={<Icon className="fas fa-file-excel"/>}
                  >
                    {valor === 0 ? ' Rutas': valor === 1 ?  'Importar  Clientes' : 'Buscar Sucursales'}
                </Button>
              
               { data.length !== 0 && <Button
                    color="primary"
                    size="small"
                    variant="outlined"
                    onClick={() => dispatch(btnExport())}
                    startIcon={<Icon className="fas fa-search"/>}
                >
                    Exportar
                </Button>}
                <Button 
                    color="primary" 
                    size="small" 
                    variant="outlined" 
                    onClick={() => onBtnClose()} 
                    startIcon={<Icon className="fas fa-door-open"/>}
                >
                    Salir
                </Button>
            </Footer>
        </Page>
    )
};

export default CargaMasivaRutas;